import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { ReportLogService } from "src/app/services/report-log.service";
import { TravelerService } from "src/app/services/traveler.service";
import { UtilityService } from "src/app/services/utility.service";

@Component({
  selector: "app-report-log-trip-selection",
  templateUrl: "./report-log-trip-selection.component.html",
  styleUrls: ["./report-log-trip-selection.component.css"],
})
export class ReportLogTripSelectionComponent implements OnInit {
  model: any = {};
  yearList: any = [];
  tripOptionList = [];
  alltripList = [];
  years = "";
  tripId = "";
  searchText = "";

  public displayedColumns = [
    //'logCreateDateDisplay',
    "formattedDate",
    "formattedTime",
    "updatedByName",
    "customerNumber",
    "companyName",
    "tripCode",
    "noOfTrips",
    "oldNoOfTrips",
  ];

  public dataSource =
    new MatTableDataSource<CustomerTripSelectionUpdateEntity>();
  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: true })
  sort: MatSort;
  response: any = {};
  constructor(
    private travelerService: TravelerService,
    public _utilityService: UtilityService,
    private reportLogService: ReportLogService
  ) {}

  ngOnInit() {
    this.yearList = this._utilityService.fillYear(
      new Date().getFullYear() - 3,
      new Date().getFullYear() + 1
    );
    this.travelerService.getTripCodeList().subscribe((result) => {
      this.alltripList = result;
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  CustomerTripUpdatedList() {
    this.dataSource.data = [];
    if (+this.tripId > 0 && +this.years > 0) {
      this.reportLogService
        .getCustomerTripUpdatedList(this.years, this.tripId)
        .subscribe((result) => {
          this.model = this.dataSource.data =
            result as CustomerTripSelectionUpdateEntity[];
          this.dataSource.paginator = this.paginator;
        });
    }
  }

  changeYear() {
    this.tripId = "";
    this.tripOptionList = [];
    if (this.alltripList && this.alltripList.length > 0)
      this.tripOptionList = this.alltripList.filter(
        (t) => t.years === this.years
      );
    this.dataSource.data = [];
  }

  changeTrip() {
    this.CustomerTripUpdatedList();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.searchText = filterValue;
    this.dataSource.filter = filterValue;
  }
  exportCustomer() {
    this.reportLogService.getCustomerTripUpdatedListExport(
      +this.years,
      +this.tripId
    );
  }
}

export interface CustomerTripSelectionUpdateEntity {
  logCreateDateDisplay: string;
  updatedByName: string;
  customerNumber: string;
  companyName: string;
  tripCode: string;
  noOfTrips: number;
  oldNoOfTrips: number;
  enrollmentId: number;
  formattedDate: string;
  formattedTime: string;
}
